import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.WalletsPage.Wallets.ConvertCurrencyPopup', {
    title: 'Currency convert',
    convert: 'Convert',
    description: 'Select the currencies you want to convert',
    fromCurrency: 'From',
    toCurrency: 'To',
    selectCurrencyPlaceholder: 'Select currency...',
    swap: 'Swap',
    enterValue: 'Enter value...',
    exchangeRate: '1 {fromCurrency} = {rate} {toCurrency} ({date})',
    insufficientBalance: 'Insufficient balance in your {currency} wallet to complete this conversion.',
});
